export function fyToPeriodEndDate(fy: string): string {
  const match = /^FY(\d{2})$/.exec(fy.trim().toUpperCase())
  if (!match?.[1]) return ''
  const yy = parseInt(match[1], 10)
  const year = yy >= 50 ? 1900 + yy : 2000 + yy
  return `${year}-06-30T00:00:00.000Z`
}

export function periodEndDateToFy(periodEndDate: string): string {
  const d = new Date(periodEndDate)
  const y = d.getUTCFullYear()
  return `FY${String(y).slice(-2)}`
}

export function getTrialBalanceAssets(
  rows: { account: string; ytdDebit: number | null; ytdCredit: number | null }[]
): { account: string; balance: number }[] {
  return rows.map((r) => {
    const debit = r.ytdDebit ?? 0
    const credit = r.ytdCredit ?? 0
    const balance = debit - credit
    return { account: r.account, balance }
  })
}

type ComplianceAmountRow = {
  status?: string | null
  matchedWorkpaperFileName?: string | null
}

export type ComplianceRowStatus = 'match' | 'mismatch' | 'missing'

export function getComplianceRowStatus(row: ComplianceAmountRow): ComplianceRowStatus {
  const normalizedStatus = String(row.status ?? '').trim().toLowerCase()
  if (normalizedStatus === 'match' || normalizedStatus === 'matched') return 'match'
  if (normalizedStatus === 'mismatch') return 'mismatch'
  if (normalizedStatus === 'missing') return 'missing'

  const hasWorkpaper = row.matchedWorkpaperFileName != null && row.matchedWorkpaperFileName.trim() !== ''
  return hasWorkpaper ? 'mismatch' : 'missing'
}

export function formatComplianceAmount(s: string): string {
  if (s == null || s === '') return '—'
  const t = String(s).trim()
  if (!t) return '—'
  const normalized = t.replace(/\$/g, '').replace(/,/g, '').replace(/\s/g, '')
  const negative = normalized.startsWith('(') && normalized.endsWith(')')
  const numStr = negative ? normalized.slice(1, -1) : normalized
  const n = Number(numStr)
  if (!Number.isFinite(n)) return t
  const v = negative ? -Math.abs(n) : n
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(v)
}
